import { useLocation } from "@opendash/router";
export function usePath() {
    return useLocation().pathname;
}
//# sourceMappingURL=usePath.js.map